import React from "react";
import { useAnalyzeLayout } from "../AnalyzeLayoutContext";
import AnalyzeInfoTab from "./InfoTab";



const InfoPanel = () => {
  const { filters, setFilters } = useAnalyzeLayout();

  return(
    <>
      <AnalyzeInfoTab 
        assetName={"pageName"}
        onSpaceLoad={(spaces)=> {}}
        onDateChange={(dateRange)=> {}}
      />
    </>
  ) 
}

export default InfoPanel;